import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingService } from 'src/app/service/booking.service';
import { finalize } from 'rxjs/operators';
import { HomeService } from 'src/app/service/home.service';
import {
  ExistingReservation,
  Reservation,
} from 'src/app/model/reservation.model';
import { ROUTES } from 'src/app/route/routes';
import { Profile } from 'src/app/model/profile.model';
import { Observable, Subject } from 'rxjs';
import { UserService } from 'src/app/service/user.service';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { Slot } from 'src/app/model/slot.model';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Event } from 'src/app/model/event.model';
import { LANGUAGES } from 'src/app/constants/lang';
import { FluxService } from 'src/app/service/flux-service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  standalone: false
})
export class SummaryComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isLoading: boolean = true;
  isMassive: boolean = false;

  reservationModel: Reservation = new Reservation();

  event_name: any;
  event_date: string;
  event_time: string;
  // event_location: string;
  selected_profiles: Array<Profile>;
  usersInWaitingList: number = 0;

  public old_reservation: ExistingReservation;
  maxNumberUsers: number = 500;

  userLanguage: string;
  public languages = LANGUAGES;
  convertTime = Slot.convertTime;
  public eventObject: Event | undefined;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bookingService: BookingService,
    private homeService: HomeService,
    private userService: UserService,
    private spinner: SpinnerService,
    private translate: TranslateService,
    private fluxService: FluxService,
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.fluxService.initializeFromRoute(this.route);
    this.userLanguage = this.userService.lang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLanguage = event.lang;
    });
    this.eventObject = this.homeService.getEventObject();

    let editReservationObject = this.homeService.getEditReservationObject();
    if (editReservationObject) {
      this.old_reservation = editReservationObject;
    }

    let slotObject = this.homeService.getSlotObject();
    let avu = null;
    if (slotObject) {
      this.reservationModel.uuid_event_occurrence =
        slotObject.uuid_event_occurrence;
      this.event_date = slotObject.displayDateTime;
      this.event_time = slotObject.occurrence_start_time;
      this.maxNumberUsers = slotObject.available_users;
      avu = slotObject.available_users;
    }

    let profileObject = this.homeService.getProfileObject();
    if (profileObject && profileObject.length > 0) {
      this.selected_profiles = profileObject;
      this.usersInWaitingList = this.selected_profiles.length - avu!;
      profileObject.forEach((el) => {
        this.reservationModel.passengers?.push(el.uuid_passenger!);
      });
    }

    if (this.userService.isEmployeeWithoutPassenger()) {
      this.isMassive = true;
    }

    this.spinner.hide();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goTo(path: string) {
    const currentFlux = this.fluxService.getCurrentFlux();
    switch (path) {
      case 'profiles': {
        if (this.isMassive) {
          this.router.navigate([currentFlux+'/'+ROUTES.EVENT_CALENDAR.path]);
        } else {
          this.router.navigate([currentFlux+'/'+ROUTES.EVENT_SELECT_PROFILE.path]);
        }
        break;
      }

      case 'complete': {
        this.router.navigate([currentFlux+'/'+ROUTES.EVENT_CONFIRMATION.path]);
      }
    }
  }

  onSubmit() {
    this.spinner.show();

    let obs: Observable<any>;

    if (this.old_reservation) {
      delete this.reservationModel.passengers;
      obs = this.bookingService.editReservation(
        this.reservationModel,
        this.old_reservation.uuid_old_reservation
      );
    } else {
      if (!this.reservationModel.number_of_users) {
        // PASSENGER RESERVATION
        delete this.reservationModel.number_of_users;
      } else {
        // BULK RESERVATION
        delete this.reservationModel.passengers;
      }
      obs = this.bookingService.createReservation(this.reservationModel);
    }

    obs
      .pipe(
        finalize(() => {
          this.goTo('complete');
        })
      )
      .subscribe({
        next: (res) => {
          this.reservationModel.users_in_wl = res.users_in_wl;
          this.homeService.saveNewReservationsObject(this.reservationModel);
        },
        error: (err) => {
          if (err.error.type == 'handled') {
            this.homeService.setErrorMessage(err.error.message);
          }
        },
      });
  }
}
